class XTools {
  constructor() {
    this.__toast = null;
    this.__toastContent = null;
    this.__toastTimer = 0;
  }
  showToast(msg, time) {
    if (this.__hasToast) {
      this._setToastMsg(msg);
      this.__toast.style.display = "block";
    } else {
      this.__toast = document.createElement("div");
      this.__toast.className = "XUtils-mask";
      this.__toastContent = document.createElement("div");
      this.__toastContent.className = "XToast-content";
      this._setToastMsg(msg);
      this.__toast.appendChild(this.__toastContent);
      document.body.appendChild(this.__toast);
      this.__hasToast = true;
      this.__toast.addEventListener("touchmove", function (ev) {
        ev.preventDefault();
      })
    }
    if (this.__toastTimer) {
      clearTimeout(this.__toastTimer);
      this.__toastTimer = 0;
    }
    this.__toastTimer = setTimeout(function () {
      this.__toast.style.display = "none";
    }.bind(this), time ? time : 2000);
  }

  _setToastMsg(msg) {
    let toastDetail = document.createElement("div");
    toastDetail.className = "XToast-detail";
    toastDetail.innerHTML = msg || "Toast";
    this.__toastContent.innerHTML = "";
    this.__toastContent.appendChild(toastDetail);
  }

  showLoading(escapeBg) {
    if (this.popMask) {
      this.popMask._targetLoading.className = "x-loading-ctr x-scaleIn" + (escapeBg ? " escape-bg" : "");
      this.popMask.style.display = "block";
    } else {
      this.popMask = document.createElement("div");
      this.popMask.className = "x-mask";
      let xLoading = this.popMask._targetLoading = document.createElement("div");
      xLoading.className = "x-loading-ctr x-scaleIn" + (escapeBg ? " escape-bg" : "");
      for (let i = 0; i < 12; ++i) {
        let loadingItem = document.createElement("div");
        loadingItem.className = "x-loading";
        loadingItem.style.webkitTransform = "rotate(" + (30 * i) + "deg) translateX(14px)";
        loadingItem.style.transform = "rotate(" + (30 * i) + "deg) translateX(14px)";
        loadingItem.style.webkitAnimationDelay = i * 50 + "ms";
        loadingItem.style.animationDelay = i * 50 + "ms";
        xLoading.appendChild(loadingItem);
      }
      this.popMask.appendChild(xLoading);
      document.body.appendChild(this.popMask);
    }
  }
  hideLoading() {
    if (this.popMask) {
      this.popMask._targetLoading.className = "x-loading-ctr x-scaleOut";
      setTimeout(() => {
        this.popMask.style.display = "none"
      }, 100);
    }
  }
  addStyle(styleList) {
    if (styleList && styleList.length) {
      if (!this.additionalCss) {
        let loadingStyle = document.createElement("style");
        document.head.insertBefore(loadingStyle, document.head.querySelector("style"));
        this.additionalCss = document.styleSheets[0];
        if (this.additionalCss.href) { //存在 link Css
          let tempStyle = null;
          for (let i = 0; i < document.styleSheets.length; ++i) {
            tempStyle = document.styleSheets[i];
            if (!tempStyle.href) {
              this.additionalCss = tempStyle;
              break;
            }
          }
        }
      }
      typeof styleList === "string" ? this.additionalCss.insertRule(styleList) : styleList.forEach(item => {
        this.additionalCss.insertRule(item);
      });
    }
  }

}

export default new XTools()
